import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import uiActions from 'tradera-state/ui/actions';
import RadioSwitch from 'tradera-components/form-controls/radio-switch';
import * as gtm from 'tradera-apps/tradera/components/discover/helpers/search-gtm';
import MaxWidthIcon from '@tradera/blueprint/theme/icons2/max-width.svg?jsx';
import MinWidthIcon from '@tradera/blueprint/theme/icons2/min-width.svg?jsx';

const trackSiteLayoutChange = siteLayout => {
    gtm.trackFilter('Site width layout', siteLayout);
};

const SiteLayoutSwitch = ({ siteLayout, className, id, updateSiteLayout }) => {
    const options = [
        {
            value: 'site-width-default',
            name: (
                <span>
                    <MinWidthIcon className="icon align-text-bottom" />
                </span>
            )
        },
        {
            value: 'site-width-full',
            name: (
                <span>
                    <MaxWidthIcon className="icon align-text-bottom" />
                </span>
            )
        }
    ];

    return (
        <RadioSwitch
            id={id}
            options={options}
            checked={siteLayout}
            handleOnChange={e => {
                updateSiteLayout(e);
                trackSiteLayoutChange(e);
            }}
            className={className}
        />
    );
};

SiteLayoutSwitch.propTypes = {
    siteLayout: PropTypes.string,
    className: PropTypes.string,
    id: PropTypes.string.isRequired
};

const mapStateToProps = state => {
    return {
        siteLayout: state.ui.siteLayout
    };
};

const mapDispatchToProps = dispatch => {
    return {
        updateSiteLayout: siteLayout =>
            dispatch(uiActions.updateSiteLayout(siteLayout))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(SiteLayoutSwitch);
